var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canLoadMore)?_c('div',{staticClass:"hiq-calendar__load-more"},[_c('button',{staticClass:"hiq-load-more",on:{"click":_vm.loadMore}},[_vm._v(_vm._s(_vm.translations.loadMore))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }